import { IconButton, Select } from '@material-ui/core';
import {
  FirstPage as FirstPageIcon,
  KeyboardArrowLeft,
  KeyboardArrowRight,
} from '@material-ui/icons';
import * as React from 'react';

export enum IPageEvent {
  FIRST_PAGE,
  BACK,
  NEXT,
}

interface IProps {
  /* totalCount: number;
  rowsPerPage: number;
  page: number;
  */
  defaultLimit: number;
  hasNextPage: boolean;
  hasPreviousPage: boolean;
  onChangePage: (event: IPageEvent, limit: number) => void;
}

interface IState {
  limit: number;
}

class TablePagination extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);
    this.state = {
      limit: props.defaultLimit,
    };
  }

  public handleFirstPageButtonClick() {
    return () => {
      this.props.onChangePage(IPageEvent.FIRST_PAGE, this.state.limit);
    };
  }

  public handleBackButtonClick() {
    return () => {
      this.props.onChangePage(IPageEvent.BACK, this.state.limit);
    };
  }

  public handleNextButtonClick() {
    return () => {
      this.props.onChangePage(IPageEvent.NEXT, this.state.limit);
    };
  }

  public handleLimitChange() {
    return (event: React.ChangeEvent<HTMLSelectElement>) => {
      const limit = Number.parseInt(event.target.value, 10);
      this.setState({
        limit,
      });
      this.props.onChangePage(IPageEvent.FIRST_PAGE, limit);
    };
  }

  public render() {
    return (
      <>
        <Select native={true} value={this.state.limit} onChange={this.handleLimitChange()}>
          <option value="" />
          <option value={10}>10</option>
          <option value={25}>25</option>
          <option value={100}>100</option>
        </Select>
        <IconButton
          onClick={this.handleFirstPageButtonClick()}
          disabled={!this.props.hasPreviousPage}
          aria-label="First Page"
        >
          <FirstPageIcon />
        </IconButton>
        <IconButton
          onClick={this.handleBackButtonClick()}
          disabled={!this.props.hasPreviousPage}
          aria-label="Previous Page"
        >
          <KeyboardArrowLeft />
        </IconButton>
        <IconButton
          onClick={this.handleNextButtonClick()}
          disabled={!this.props.hasNextPage}
          aria-label="Next Page"
        >
          <KeyboardArrowRight />
        </IconButton>
      </>
    );
  }
}

export default TablePagination;



// WEBPACK FOOTER //
// ./src/components/TablePagination/TablePagination.tsx